import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-none"
}
const _hoisted_2 = { class: "fs-20 mt-4 mb-2" }
const _hoisted_3 = {
  key: 0,
  for: "opening-time",
  class: "mb-1"
}
const _hoisted_4 = {
  key: 1,
  class: "p-field-radiobutton"
}
const _hoisted_5 = {
  key: 2,
  class: "p-field-radiobutton"
}
const _hoisted_6 = {
  key: 3,
  class: "p-field-radiobutton"
}
const _hoisted_7 = {
  key: 4,
  class: "p-field-radiobutton"
}
const _hoisted_8 = {
  key: 5,
  class: "mt-4"
}
const _hoisted_9 = { class: "px-3" }
const _hoisted_10 = { class: "fs-12 text-right text-gray mt-3" }
const _hoisted_11 = { class: "p-field-radiobutton" }
const _hoisted_12 = {
  key: 6,
  class: "p-field-radiobutton"
}
const _hoisted_13 = {
  key: 7,
  class: "p-field-radiobutton"
}
const _hoisted_14 = { key: 8 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Slider = _resolveComponent("Slider")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.deviceName)
      ? (_openBlock(), _createBlock("h3", _hoisted_1, _toDisplayString(_ctx.deviceName), 1))
      : _createCommentVNode("", true),
    _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.CommandSettingsMode")), 1),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settings.slots, (s, index) => {
      return (_openBlock(), _createBlock("div", {
        key: `slot-${index}`,
        class: "mb-4"
      }, [
        (s.hasMoreThanOneSlotSettings)
          ? (_openBlock(), _createBlock("h6", _hoisted_3, " Slot " + _toDisplayString(index), 1))
          : _createCommentVNode("", true),
        (s.isOptionOnOffVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_RadioButton, {
                id: `slot-${index}-LightsOnOffMode.OnOffRegulation`,
                name: "LightsOnOffMode",
                value: _ctx.LightsOnOffMode.OnOffRegulation,
                modelValue: s.lightsOnOffMode,
                "onUpdate:modelValue": ($event: any) => (s.lightsOnOffMode = $event),
                disabled: _ctx.readonly
              }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", {
                for: `slot-${index}-LightsOnOffMode.OnOffRegulation`
              }, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionOnOff")), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (s.isOptionOffVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_RadioButton, {
                id: `slot-${index}-LightsOnOffMode.Off`,
                name: "LightsOnOffMode",
                value: _ctx.LightsOnOffMode.Off,
                modelValue: s.lightsOnOffMode,
                "onUpdate:modelValue": ($event: any) => (s.lightsOnOffMode = $event),
                disabled: _ctx.readonly
              }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", {
                for: `slot-${index}-LightsOnOffMode.Off`
              }, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionOff")), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (s.isOptionOnVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode(_component_RadioButton, {
                id: `slot-${index}-LightsOnOffMode.On`,
                name: "LightsOnOffMode",
                value: _ctx.LightsOnOffMode.On,
                modelValue: s.lightsOnOffMode,
                "onUpdate:modelValue": ($event: any) => (s.lightsOnOffMode = $event),
                disabled: _ctx.readonly
              }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", {
                for: `slot-${index}-LightsOnOffMode.On`
              }, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionOn")), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (s.isOptionOnRegulationVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_RadioButton, {
                id: `slot-${index}-LightsOnOffMode.OnRegulation`,
                name: "LightsOnOffMode",
                value: _ctx.LightsOnOffMode.OnRegulation,
                modelValue: s.lightsOnOffMode,
                "onUpdate:modelValue": ($event: any) => (s.lightsOnOffMode = $event),
                disabled: _ctx.readonly
              }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", {
                for: `slot-${index}-LightsOnOffMode.OnRegulation`
              }, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionOnRegulation")), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (s.lightsOnOffMode === _ctx.LightsOnOffMode.OnRegulation)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_Slider, {
                  modelValue: s.minimumRegulationLevel,
                  "onUpdate:modelValue": ($event: any) => (s.minimumRegulationLevel = $event),
                  orientation: "horizontal",
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("div", _hoisted_10, _toDisplayString(s.minimumRegulationLevel), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_RadioButton, {
            id: `slot-${index}-LightsOnOffMode.Toggle`,
            name: "LightsOnOffMode",
            value: _ctx.LightsOnOffMode.Toggle,
            modelValue: s.lightsOnOffMode,
            "onUpdate:modelValue": ($event: any) => (s.lightsOnOffMode = $event),
            disabled: _ctx.readonly
          }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "disabled"]),
          _createVNode("label", {
            for: `slot-${index}-LightsOnOffMode.Toggle`
          }, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionToggle")), 9, ["for"])
        ]),
        (s.isOptionButtonVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _createVNode(_component_RadioButton, {
                id: `slot-${index}-LightsOnOffMode.Button`,
                name: "LightsOnOffMode",
                value: _ctx.LightsOnOffMode.Button,
                modelValue: s.lightsOnOffMode,
                "onUpdate:modelValue": ($event: any) => (s.lightsOnOffMode = $event),
                disabled: _ctx.readonly
              }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", {
                for: `slot-${index}-LightsOnOffMode.Button`
              }, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionButton")), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (s.isOptionTimedVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode(_component_RadioButton, {
                id: `slot-${index}-LightsOnOffMode.Timed`,
                name: "LightsOnOffMode",
                value: _ctx.LightsOnOffMode.Timed,
                modelValue: s.lightsOnOffMode,
                "onUpdate:modelValue": ($event: any) => (s.lightsOnOffMode = $event),
                disabled: _ctx.readonly
              }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", {
                for: `slot-${index}-LightsOnOffMode.Timed`
              }, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionTimed")), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (s.isTimedDelayVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.CommandSettingsDelayTimePickerHeader")), 1),
              _createVNode(_component_Dropdown, {
                modelValue: s.timedDelayPickerSelectedValue,
                "onUpdate:modelValue": ($event: any) => (s.timedDelayPickerSelectedValue = $event),
                options: s.timedDelayPickerValues,
                optionLabel: "description",
                optionValue: "value",
                class: "has--border",
                disabled: _ctx.readonly
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}